import React from "react";
import visionImage from "../images/about.jpg";

const VisionMissionSection = () => {
  return (
    <section className="vision-mission-section">
      {/* Left Side Image */}
      <div className="flex justify-center md:w-1/2 w-full">
        <img
          src={visionImage}
          alt="Tours and Travels Poster"
          className="vision-image"
        />
      </div>

      {/* Right Side Content */}
      <div className="vision-content">
        <h3 className="vision-title">Our Goal</h3>

        <h2 className="vision-heading">Vision:</h2>
        <p className="vision-text">
          Our vision at Meghana Cabs is to establish ourselves as the foremost and most
          trusted cab service provider across India. We aspire to redefine the
          transportation landscape by offering safe, convenient, and eco-friendly
          solutions that consistently surpass customer expectations. As we work
          towards this vision, we are committed to contributing positively to the
          communities we serve and minimizing our impact on the environment.
        </p>

        <h2 className="vision-heading">Mission:</h2>
        <p className="vision-text">
          Our mission is centered on several key principles. First and foremost, we aim
          to provide our customers with transportation services that are not only safe
          but also highly dependable, ensuring our comfort and satisfaction on every
          journey. We maintain a diverse fleet of vehicles to cater to the unique needs
          and preferences of our passengers, all while upholding the highest standards
          of professionalism and safety through continuous driver training and
          empowerment.
        </p>
      </div>
    </section>
  );
};

export default VisionMissionSection;
